module.exports = __webpack_public_path__ + "static/media/din_certco_9G0097.3d1250af.png";